import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import BusinessPlan from "@/pages/BusinessPlan";
import "@/App.css";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<BusinessPlan />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
